

    /**
     * Returns a function that gets a property of the passed object
     */
    function prop(name){
        return function(obj){
            return obj[name];
        };
    }

    module.exports = prop;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/prop.js
// module id = 386
// module chunks = 0 1 2